import React from 'react'

const CardHeader = ({children, className = ''}) => {
    return (
        <div 
            className={`text-xs font-bold brand-text border-b brand-border w-full py-2 flex items-center ${className}`.trim()}>
                {children}
        </div>
    )
}

export default CardHeader
